module.exports = __webpack_public_path__ + "static/media/trident_01.da253add.jpg";